/* eslint-disable no-await-in-loop */
import _ from 'lodash';
import { internalApi } from '../api';
import helpers from './helpers';
import tasksComponent from '../../components/tasks';
import resourcesOverload from '../../components/resourcesOverload';
import historyModel from '../../models/history';
import ganttViewModel from '$$ganttViewModel';
import statusHelper from '../../helpers/status';

export default {
  async createTasks({ commit }, payload) {
    const {
      tasks, sourceEvent, fromGantt, multiviewId = null,
    } = payload;

    const actionHash = payload.actionHash || historyModel.generateActionHash();
    const createData = await tasksComponent.prepareTasksCreateData(tasks, fromGantt);

    if (!_.isEmpty(createData.createdTasksForCommit)) {
      commit('addTasks', { tasks: createData.createdTasksForCommit, fromGantt: createData.fromGantt });
    }

    if (!_.isEmpty(createData.updatedTasksForCommit)) {
      commit('updateTasks', { tasks: createData.updatedTasksForCommit, fromGantt: createData.fromGantt });
    }

    if (!_.isEmpty(createData.resourcesToTasksForCommit)) {
      commit('updateResourcesToTasks', { resourcesToTasks: createData.resourcesToTasksForCommit, fromGantt: createData.fromGantt });
    }

    if (!_.isEmpty(createData.tasksCustomValuesForCommit)) {
      commit('updateTasksCustomValues', { tasksCustomValues: createData.tasksCustomValuesForCommit, fromGantt: createData.fromGantt });
    }

    if (!_.isEmpty(createData.userCustomValuesForCommit)) {
      commit('columns/updateUserCustomValues', { userCustomValues: createData.userCustomValuesForCommit, fromGantt: createData.fromGantt }, { root: true });
    }

    if (_.isEmpty(createData.createdMap)) {
      return [];
    }

    if (!sourceEvent.sourceId) {
      sourceEvent.sourceId = createData.createdTasksForCommit[0].id;
    }

    let inProgress = false;
    const timeout = setTimeout(() => {
      inProgress = true;
      statusHelper.handlers.showMainSpinner();
    }, 2000);

    const { data } = await internalApi.post('/ganttview/tasks', {
      actionHash,
      metadata: sourceEvent,
      multiviewId,
      createdMap: helpers.prepareTaskMapForRequest(createData.createdMap),
    }).catch(error => {
      commit('deleteTasks', { tasks: createData.createdTasksForCommit, fromGantt: false });
      throw error;
    }).finally(() => {
      clearTimeout(timeout);
      inProgress && statusHelper.handlers.hideMainSpinner();
    });

    if (!_.isEmpty(createData.updatedMap)) {
      await internalApi.put('/ganttview/tasks', {
        actionHash,
        metadata: sourceEvent,
        multiviewId,
        updatedMap: helpers.prepareTaskMapForRequest(createData.updatedMap),
      });
    }

    if (!_.isEmpty(data?.createdTasks)) {
      commit('updateTasksIds', { createdTasks: data.createdTasks, fromGantt: false });

      if (createData.tasksCustomValuesForCommit.length) {
        commit('updateTasksCustomValuesTasksIds', { tasks: data.createdTasks, fromGantt: false });
      }

      if (createData.userCustomValuesForCommit.length) {
        commit('columns/updateUserCustomValuesTasksIds', { tasks: data.createdTasks, fromGantt: false }, { root: true });
      }
    }

    if (!_.isEmpty(data?.updatedResourcesToTasks)) {
      commit('updateResourcesToTasksIds', { resourcesToTasks: data.updatedResourcesToTasks, fromGantt: false });
    }

    if (createData.refreshOverload) {
      resourcesOverload.refreshCache();
    }

    return data ? data.createdTasks.map(task => +task.targetTaskId) : [];
  },

  async updateTasks({ dispatch, commit }, payload) {
    const {
      tasks, sourceEvent, fromGantt, multiviewId = null,
    } = payload;

    dispatch('copyPaste/setCopyPasteError', { taskIds: tasks.map(t => +t.id), text: 'can_not_copy_changes' }, { root: true });

    const actionHash = payload.actionHash || historyModel.generateActionHash();
    const updateData = await tasksComponent.prepareTasksUpdateData(tasks, multiviewId, fromGantt, sourceEvent);

    if (!_.isEmpty(updateData.updatedTasksForCommit)) {
      commit('updateTasks', { tasks: updateData.updatedTasksForCommit, fromGantt: updateData.fromGantt });
    }

    if (!_.isEmpty(updateData.resourcesToTasksForCommit)) {
      commit('updateResourcesToTasks', { resourcesToTasks: updateData.resourcesToTasksForCommit, fromGantt: updateData.fromGantt });
    }

    if (!_.isEmpty(updateData.tasksCustomValuesForCommit)) {
      commit('updateTasksCustomValues', { tasksCustomValues: updateData.tasksCustomValuesForCommit, fromGantt: updateData.fromGantt });
    }

    if (!_.isEmpty(updateData.userCustomValuesForCommit)) {
      commit('columns/updateUserCustomValues', { userCustomValues: updateData.userCustomValuesForCommit, fromGantt: updateData.fromGantt }, { root: true });
    }

    if (!_.isEmpty(updateData.multiviewValuesForCommit)) {
      ganttViewModel.updateMultiviewValues(updateData.multiviewValuesForCommit);
    }

    if (_.isEmpty(updateData.updatedMap)) {
      return;
    }

    const { data } = await internalApi.put('/ganttview/tasks', {
      actionHash,
      metadata: sourceEvent,
      multiviewId,
      updatedMap: helpers.prepareTaskMapForRequest(updateData.updatedMap),
    });

    if (!_.isEmpty(data?.updatedResourcesToTasks)) {
      commit('updateResourcesToTasksIds', { resourcesToTasks: data.updatedResourcesToTasks, fromGantt: false });
    }

    if (updateData.refreshOverload) {
      resourcesOverload.refreshCache();
    }
  },

  async deleteTasks({ commit }, payload) {
    const {
      tasks, sourceEvent, fromGantt, multiviewId = null,
    } = payload;

    const actionHash = payload.actionHash || historyModel.generateActionHash();
    const deleteData = await tasksComponent.prepareTasksDeleteData(tasks, fromGantt);

    if (!_.isEmpty(deleteData.deletedTasksForCommit)) {
      commit('deleteTasks', { tasks: deleteData.deletedTasksForCommit, fromGantt: deleteData.fromGantt });
      commit('comments/deleteTasksComments', { tasks: deleteData.deletedTasksForCommit, fromGantt: deleteData.fromGantt }, { root: true });
    }

    if (!_.isEmpty(deleteData.updatedTasksForCommit)) {
      commit('updateTasks', { tasks: deleteData.updatedTasksForCommit, fromGantt: deleteData.fromGantt });
    }

    if (_.isEmpty(deleteData.deletedTasksForCommit)) {
      return;
    }

    await internalApi.delete('/ganttview/tasks', {
      data: {
        actionHash,
        metadata: sourceEvent,
        multiviewId,
        taskIds: _.uniq(deleteData.deletedTasksForCommit.map(task => +task.id)),
      },
    });

    if (!_.isEmpty(deleteData.updatedMap)) {
      await internalApi.put('/ganttview/tasks', {
        actionHash,
        metadata: sourceEvent,
        multiviewId,
        updatedMap: helpers.prepareTaskMapForRequest(deleteData.updatedMap),
      });
    }

    if (deleteData.refreshOverload) {
      resourcesOverload.refreshCache();
    }
  },

  async createLinks({ commit }, payload) {
    const {
      links, sourceEvent, fromGantt, multiviewId = null,
    } = payload;

    const actionHash = payload.actionHash || historyModel.generateActionHash();
    const createData = await tasksComponent.prepareLinksCreateData(links, fromGantt);

    if (!_.isEmpty(createData.createdLinksForCommit)) {
      commit('addLinks', { links: createData.createdLinksForCommit, fromGantt: createData.fromGantt });
    }

    if (!_.isEmpty(createData.updatedTasksForCommit)) {
      commit('updateTasks', { tasks: createData.updatedTasksForCommit, fromGantt: createData.fromGantt });
    }

    if (_.isEmpty(createData.createdLinkMap)) {
      return [];
    }

    if (!sourceEvent.sourceId) {
      sourceEvent.sourceId = createData.createdLinksForCommit[0].id;
    }

    let inProgress = false;
    const timeout = setTimeout(() => {
      inProgress = true;
      statusHelper.handlers.showMainSpinner();
    }, 2000);

    const { data } = await internalApi.post('/ganttview/links', {
      actionHash,
      metadata: sourceEvent,
      multiviewId,
      createdMap: createData.createdLinkMap,
    }).catch(error => {
      commit('removeLinks', { links: createData.createdLinksForCommit, fromGantt: false });
      throw error;
    }).finally(() => {
      clearTimeout(timeout);
      inProgress && statusHelper.handlers.hideMainSpinner();
    });

    if (!_.isEmpty(createData.updatedTaskMap)) {
      await internalApi.put('/ganttview/tasks', {
        actionHash,
        metadata: sourceEvent,
        multiviewId,
        updatedMap: helpers.prepareTaskMapForRequest(createData.updatedTaskMap),
      });
    }

    if (data?.createdLinks) {
      commit('updateLinksIds', { createdLinks: data.createdLinks, fromGantt: false });
    }

    if (createData.refreshOverload) {
      resourcesOverload.refreshCache();
    }

    return data ? data.createdLinks.map(link => +link.targetLinkId) : [];
  },

  async updateLinks({ commit }, payload) {
    const {
      links, sourceEvent, fromGantt, multiviewId = null,
    } = payload;

    const actionHash = payload.actionHash || historyModel.generateActionHash();
    const updateData = await tasksComponent.prepareLinksUpdateData(links, fromGantt);

    if (!_.isEmpty(updateData.updatedLinksForCommit)) {
      commit('updateLinks', { links: updateData.updatedLinksForCommit, fromGantt: updateData.fromGantt });
    }

    if (!_.isEmpty(updateData.updatedTasksForCommit)) {
      commit('updateTasks', { tasks: updateData.updatedTasksForCommit, fromGantt: updateData.fromGantt });
    }

    if (_.isEmpty(updateData.updatedLinkMap)) {
      return;
    }

    await internalApi.put('/ganttview/links', {
      actionHash,
      metadata: sourceEvent,
      multiviewId,
      updatedMap: updateData.updatedLinkMap,
    });

    if (!_.isEmpty(updateData.updatedTaskMap)) {
      await internalApi.put('/ganttview/tasks', {
        actionHash,
        metadata: sourceEvent,
        multiviewId,
        updatedMap: helpers.prepareTaskMapForRequest(updateData.updatedTaskMap),
      });
    }

    if (updateData.refreshOverload) {
      resourcesOverload.refreshCache();
    }
  },

  async deleteLinks({ commit }, payload) {
    const {
      links, sourceEvent, fromGantt, multiviewId = null,
    } = payload;

    const actionHash = payload.actionHash || historyModel.generateActionHash();

    if (_.isEmpty(links)) {
      return;
    }

    commit('removeLinks', { links, fromGantt });

    await internalApi.delete('/ganttview/links', {
      data: {
        actionHash,
        metadata: sourceEvent,
        multiviewId,
        linkIds: links.map(link => link.id),
      },
    });
  },
};
